import { render, staticRenderFns } from "./TeacherInfo.vue?vue&type=template&id=4d81780d&scoped=true"
import script from "./TeacherInfo.vue?vue&type=script&lang=js"
export * from "./TeacherInfo.vue?vue&type=script&lang=js"
import style0 from "./TeacherInfo.vue?vue&type=style&index=0&id=4d81780d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d81780d",
  null
  
)

export default component.exports